export const tableConfig = [
  {
    key: "name",
    label: "Name",
    headerStyle: { display: "none" },
    cellStyle: { width: "150px", minWidth: "150px" },
  },
  {
    key: "totalEngineNumber",
    label: "Jumlah Nosin",
  },
  {
    key: "kpb1NotUsed",
    label: "Belum Terpakai",
  },
  {
    key: "kpb1NotUsedPercentage",
    label: "Belum Terpakai (%)",
  },
  {
    key: "kpb1Used",
    label: "Terpakai",
  },
  {
    key: "kpb1UsedPercentage",
    label: "Terpakai (%)",
  },
  {
    key: "kpb1Expired",
    label: "Kadaluarsa",
  },
  {
    key: "kpb1ExpiredPercentage",
    label: "Kadaluarsa (%)",
  },
  {
    key: "kpb2NotUsed",
    label: "Belum Terpakai",
  },
  {
    key: "kpb2NotUsedPercentage",
    label: "Belum Terpakai (%)",
  },
  {
    key: "kpb2Used",
    label: "Terpakai",
  },
  {
    key: "kpb2UsedPercentage",
    label: "Terpakai (%)",
  },
  {
    key: "kpb2Expired",
    label: "Kadaluarsa",
  },
  {
    key: "kpb2ExpiredPercentage",
    label: "Kadaluarsa (%)",
  },
  {
    key: "kpb3NotUsed",
    label: "Belum Terpakai",
  },
  {
    key: "kpb3NotUsedPercentage",
    label: "Belum Terpakai (%)",
  },
  {
    key: "kpb3Used",
    label: "Terpakai",
  },
  {
    key: "kpb3UsedPercentage",
    label: "Terpakai (%)",
  },
  {
    key: "kpb3Expired",
    label: "Kadaluarsa",
  },
  {
    key: "kpb3ExpiredPercentage",
    label: "Kadaluarsa (%)",
  },
  {
    key: "kpb4NotUsed",
    label: "Belum Terpakai",
  },
  {
    key: "kpb4NotUsedPercentage",
    label: "Belum Terpakai (%)",
  },
  {
    key: "kpb4Used",
    label: "Terpakai",
  },
  {
    key: "kpb4UsedPercentage",
    label: "Terpakai (%)",
  },
  {
    key: "kpb4Expired",
    label: "Kadaluarsa",
  },
  {
    key: "kpb4ExpiredPercentage",
    label: "Kadaluarsa (%)",
  },
];

export const groupHeaders = [
  {
    label: " ",
    colSpan: 1,
    rowSpan: 2,
    style: {
      verticalAlign: "middle",
    },
  },
  {
    label: "KPB 1",
    colSpan: 7,
  },
  {
    label: "KPB 2",
    colSpan: 6,
  },
  {
    label: "KPB 3",
    colSpan: 6,
  },
  {
    label: "KPB 4",
    colSpan: 6,
  },
];

export const generatePayloadPrint = (data) => ({
  filename: "Laporan_Monitoring_KPB_CRM_Kabeng_Kacab",
  sheets: [
    {
      name: "Report",
      headers: [
        {
          key: "name",
        },
        {
          title: "KPB 1",
          children: [
            {
              key: "totalEngineNumber",
              title: "Total Nosin",
            },
            {
              key: "kpb1NotUsed",
              title: "Belum Terpakai",
            },
            {
              key: "kpb1NotUsedPercentage",
              title: "Belum Terpakai (%)",
            },
            {
              key: "kpb1Used",
              title: "Terpakai",
            },
            {
              key: "kpb1UsedPercentage",
              title: "Terpakai (%)",
            },
            {
              key: "kpb1Expired",
              title: "Kadaluarsa",
            },
            {
              key: "kpb1ExpiredPercentage",
              title: "Kadaluarsa (%)",
            },
          ],
        },
        {
          title: "KPB 2",
          children: [
            {
              key: "kpb2NotUsed",
              title: "Belum Terpakai",
            },
            {
              key: "kpb2NotUsedPercentage",
              title: "Belum Terpakai (%)",
            },
            {
              key: "kpb2Used",
              title: "Terpakai",
            },
            {
              key: "kpb2UsedPercentage",
              title: "Terpakai (%)",
            },
            {
              key: "kpb2Expired",
              title: "Kadaluarsa",
            },
            {
              key: "kpb2ExpiredPercentage",
              title: "Kadaluarsa (%)",
            },
          ],
        },
        {
          title: "KPB 3",
          children: [
            {
              key: "kpb3NotUsed",
              title: "Belum Terpakai",
            },
            {
              key: "kpb3NotUsedPercentage",
              title: "Belum Terpakai (%)",
            },
            {
              key: "kpb3Used",
              title: "Terpakai",
            },
            {
              key: "kpb3UsedPercentage",
              title: "Terpakai (%)",
            },
            {
              key: "kpb3Expired",
              title: "Kadaluarsa",
            },
            {
              key: "kpb3ExpiredPercentage",
              title: "Kadaluarsa (%)",
            },
          ],
        },
        {
          title: "KPB 4",
          children: [
            {
              key: "kpb4NotUsed",
              title: "Belum Terpakai",
            },
            {
              key: "kpb4NotUsedPercentage",
              title: "Belum Terpakai (%)",
            },
            {
              key: "kpb4Used",
              title: "Terpakai",
            },
            {
              key: "kpb4UsedPercentage",
              title: "Terpakai (%)",
            },
            {
              key: "kpb4Expired",
              title: "Kadaluarsa",
            },
            {
              key: "kpb4ExpiredPercentage",
              title: "Kadaluarsa (%)",
            },
          ],
        },
      ],
      data: data,
    },
  ],
});
